import { selector, selectorFamily } from 'recoil';
import { formState } from '.';
import getIssuesForNodes from '../utils/getIssuesForNodes';
import type { FormBuilder_Locale } from '~/graphql/types';
import getIssuesForForm from '../utils/getIssuesForForm';

export type Issue = {
  level: 'error' | 'warning' | null;
  nodeId?: string | null;
  blockKey?: string | null;
  optionKey?: string | null;
  localeKey?: FormBuilder_Locale;
  message: string;
};

export const issueState = selector<Array<Issue>>({
  key: 'formBuilder/issueState',
  get: ({ get }) => {
    const form = get(formState);
    if (!form) return [];

    return [...getIssuesForForm(form), ...getIssuesForNodes(form)];
  },
});

export const issuesByPath = selectorFamily<
  Array<Issue | null>,
  [string, string] | [string]
>({
  key: 'formBuilder/issuesByBlockId',
  get:
    pathToBlock =>
    ({ get }) => {
      const issues = get(issueState);
      if (!issues) return [];

      const issuesForNode = issues.filter(
        issue => issue.nodeId === pathToBlock[0],
      );

      if (!pathToBlock[1]) return issuesForNode;

      const issuesForBlock = issuesForNode.filter(
        issue => issue.blockKey === pathToBlock[1],
      );

      return issuesForBlock;
    },
});
